import React from 'react'
import Box from './box'
import { grid } from './variables'
import merge from 'deepmerge'

interface ICol {
  css?: {}
  first?: boolean
  last?: boolean
  size?: number | number[]
  push?: number | number[]
  order?: number | number[]
  grow?: number | number[]
  shrink?: number | number[]
  hide?: boolean | boolean[]
  align?:
    | 'start'
    | 'end'
    | 'center'
    | 'stretch'
    | 'baseline'
    | Array<'start' | 'end' | 'center' | 'stretch' | 'baseline'>
}

class Col extends React.Component<ICol, any> {
  public styleProps: {}
  constructor(props) {
    super(props)
    this.styleProps = this.props.css ? this.props.css : {}
  }
  public render() {
    return (
      <Box
        {...this.props}
        css={merge.all([containerStyle(this.props), this.props.css || {}])}
      >
        {this.props.children}
      </Box>
    )
  }
}

const containerStyle = props => {
  const style: any = {}
  // if first or last col remove padding from gutter
  const removeGutter = props.first || props.last ? grid.gutter / 2 : grid.gutter

  if (props.size && Array.isArray(props.size)) {
    style.paddingRight = props.size.map(
      size =>
        size === grid.columns || props.last ? '0px' : `${grid.gutter / 2}px`
    )
    style.paddingLeft = props.size.map(
      size =>
        size === grid.columns || props.first ? '0px' : `${grid.gutter / 2}px`
    )
    style.width = props.size.map(
      size =>
        size === grid.columns
          ? '100%'
          : `calc((${size / grid.columns} * 100%) - ${removeGutter}px)`
    )
  } else if (props.size) {
    style.paddingRight =
      props.size === grid.columns || props.last ? '0px' : `${grid.gutter / 2}px`
    style.paddingLeft =
      props.size === grid.columns || props.first
        ? '0px'
        : `${grid.gutter / 2}px`
    style.width =
      props.size === grid.columns
        ? '100%'
        : `calc((${props.size / grid.columns} * 100%) - ${removeGutter}px)`
  }

  if (props.push && Array.isArray(props.push)) {
    const removeGutter =
      props.first || props.last ? grid.gutter / 2 : grid.gutter

    style.marginLeft = props.push.map(
      push =>
        push === grid.columns
          ? '100%'
          : `calc((${push / grid.columns} * 100%) + ${grid.gutter -
              removeGutter}px)`
    )
  } else if (props.push) {
    style.marginLeft =
      props.push === grid.columns
        ? '100%'
        : `calc((${props.push / grid.columns} * 100%) + ${grid.gutter -
            removeGutter}px)`
  }

  if (props.grow || props.shrink) {
    if (props.grow && props.shrink) {
      style.flex = props.grow + ' ' + props.shrink + ' auto'
    } else if (props.grow) {
      style.flex = props.grow + ' 0 auto'
    } else if (props.shrink) {
      style.flex = '0 ' + props.shrink + ' auto'
    } else {
      style.flex = '0 1 auto'
    }
  }

  if (props.order) {
    Array.isArray(props.order)
      ? (style.order = props.size.map(
          order => `calc((${order / grid.columns} * 100%) - ${grid.gutter}px)`
        ))
      : (style.order = `calc((${props.order / grid.columns} * 100%) - ${
          grid.gutter
        }px)`)
  }

  if (props.hasOwnProperty('hide')) {
    Array.isArray(props.hide)
      ? (style.display = props.hide.map(hide => (hide ? 'none' : 'block')))
      : (style.display = props.hide ? 'none' : 'block')
  }

  if (props.align) {
    if (Array.isArray(props.align)) {
      style.alignSelf = props.align.map(align => {
        if (align === 'start') {
          return 'flex-start'
        } else if (align === 'end') {
          return 'flex-end'
        } else if (align === 'center') {
          return 'center'
        } else if (align === 'baseline') {
          return 'baseline'
        } else if (align === 'stretch') {
          return 'stretch'
        }
        return ''
      })
    } else {
      if (props.align === 'start') {
        style.alignSelf = 'flex-start'
      } else if (props.align === 'end') {
        style.alignSelf = 'flex-end'
      } else if (props.align === 'center') {
        style.alignSelf = 'center'
      } else if (props.align === 'baseline') {
        style.alignSelf = 'baseline'
      } else if (props.align === 'stretch') {
        style.alignSelf = 'stretch'
      }
      style.alignSelf = ''
    }
  }
  return style
}

export default Col
